export class Organism {
	constructor(component_key) {
		this.id = component_key;
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		this.init_forms();
	}

	init_forms() {}
}